// Seasons arrive in the maintenance list order (orden and cod_tem descending).
export function defaultManufacturingSeason(seasons = []) {
  return seasons.find((season) => season.defecto && season.cod_tem?.trim())?.cod_tem.trim() || "";
}
